import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopProfileBottom728x90Fs from './freestar/DesktopProfileBottom728x90';
import DesktopProfileBottom728x90Tab from './taboola/DesktopProfileBottom728x90';
const DesktopProfileBottom728x90 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopProfileBottom728x90Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopProfileBottom728x90Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopProfileBottom728x90.displayName = 'DesktopProfileBottom728x90';
export default DesktopProfileBottom728x90;
